// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "25.2.0",
  "buildNumber": "20485",
  "gitSha": "2720963f2a829313e1f7922fc430682259e36a6d",
  "fullVersion": "25.2.0-20485",
  "formattedVersion": "25.2.0 (20485-2720963f2a829313e1f7922fc430682259e36a6d)"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/25.2.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/25.2.0/${stripLeadingPrefix(suffix, '#')}`
}
    
